import { createSlice } from '@reduxjs/toolkit'
import { createAsyncActions } from '@/utils/sagas'

export const initialState = {
  items: [],
  isFetching: false,
  error: null,
}

export const readDirectCharge = createAsyncActions('directCharge/read')
export const createDirectCharge = createAsyncActions('directCharge/create')
export const acceptDirectCharge = createAsyncActions('directCharge/accept')
export const declineDirectCharge = createAsyncActions('directCharge/decline')
export const activateDirectCharge = createAsyncActions('directCharge/activate')

const directChargesSlice = createSlice({
  name: 'directCharge',
  initialState,
  reducers: {
    directChargePollStart(state) {
      state.isFetching = true
    },
    directChargePollStop(state) {
      state.isFetching = false
    },
    archiveDirectCharge(state, { payload }) {
      const itemId = payload?.json?.id || payload?.item?.id
      state.items = state.items.filter((item) => item.id !== itemId)
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(acceptDirectCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(acceptDirectCharge.fulfilled, (state) => {
      state.isFetching = false
    })

    addCase(acceptDirectCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(declineDirectCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(declineDirectCharge.fulfilled, (state) => {
      state.isFetching = false
    })

    addCase(declineDirectCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(activateDirectCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(activateDirectCharge.fulfilled, (state, { payload }) => {
      const itemIndex = state.items.findIndex(
        (item) => item.id === payload?.item?.id
      )

      state.isFetching = false
      state.items[itemIndex] = payload.item
    })

    addCase(activateDirectCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(createDirectCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(createDirectCharge.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items.push(payload?.item)
    })

    addCase(createDirectCharge.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })

    addCase(readDirectCharge.pending, (state) => {
      state.isFetching = true
    })

    addCase(readDirectCharge.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items.push(payload?.item)
    })

    addCase(readDirectCharge.rejected, (state) => {
      state.isFetching = false
    })
  },
})

export const {
  directChargePollStart,
  directChargePollStop,
  archiveDirectCharge,
} = directChargesSlice.actions
export const reducer = directChargesSlice.reducer
